import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { adminApi } from "@/lib/adminAuth";
import { toast } from "sonner";
import { Key, XCircle, Copy, CheckCircle2 } from "lucide-react";

export default function AdminPasswordResets() {
  const [items, setItems] = useState([]);
  const [tab, setTab] = useState("pending");
  const [passwords, setPasswords] = useState({});
  const [notes, setNotes] = useState({});

  const load = () => {
    const params = tab && tab !== "all" ? `?status=${tab}` : "";
    api.get(`/admin/password-resets${params}`, adminApi()).then(({ data }) => setItems(data));
  };
  useEffect(() => { load(); }, [tab]);  // eslint-disable-line

  const generatePwd = () => Math.random().toString(36).slice(-8) + Math.floor(Math.random() * 10);

  const resetPassword = async (item) => {
    const pwd = passwords[item.id] || generatePwd();
    if (!item.user_id) { toast.error("Bu email ile kayıtlı kullanıcı yok"); return; }
    try {
      const { data } = await api.post(`/admin/users/${item.user_id}/reset-password`, { new_password: pwd }, adminApi());
      setPasswords({ ...passwords, [item.id]: data.new_password });
      toast.success(`Yeni şifre: ${data.new_password} — Kullanıcıya iletin`);
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Şifre atanamadı"); }
  };

  const reject = async (rid) => {
    try { await api.post(`/admin/password-resets/${rid}/reject`, { notes: notes[rid] || "" }, adminApi()); toast.info("Reddedildi"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Hata"); }
  };

  const copy = (txt) => { navigator.clipboard.writeText(txt); toast.success("Kopyalandı"); };

  return (
    <div className="font-admin-body" data-testid="admin-password-resets">
      <h1 className="font-admin-head text-3xl mb-4">Şifre Sıfırlama Talepleri</h1>
      <div className="flex gap-2 mb-4">
        {[["pending","Bekleyen"],["resolved","Çözülmüş"],["rejected","Red"],["all","Tümü"]].map(([k,l]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`pr-tab-${k}`} className={`px-3 py-1.5 rounded-full text-sm ${tab === k ? "bg-[#F59E0B]/20 text-[#F59E0B]" : "bg-white/5 text-white/60"}`}>{l}</button>
        ))}
      </div>

      <div className="space-y-2">
        {items.map((r) => (
          <div key={r.id} className="admin-card p-4" data-testid={`pr-${r.id}`}>
            <div className="flex items-start justify-between gap-4 flex-wrap">
              <div className="flex-1 min-w-[200px]">
                <div className="font-admin-head text-lg">{r.email} <button onClick={() => copy(r.email)} className="text-white/40 hover:text-white"><Copy className="w-3.5 h-3.5 inline" /></button></div>
                <div className="text-xs text-white/60">{r.user_name || "(kayıtlı kullanıcı yok)"}{r.phone ? ` • Tel: ${r.phone}` : ""}</div>
                {r.reason && <div className="text-xs text-white/50 mt-1 italic">"{r.reason}"</div>}
                <div className="text-[10px] text-white/40 mt-1">{new Date(r.created_at).toLocaleString("tr-TR")}</div>
              </div>
              <div className="flex items-center gap-2">
                <span className={`text-xs px-2 py-1 rounded-full ${r.status === "resolved" ? "bg-emerald-500/20 text-emerald-300" : r.status === "rejected" ? "bg-red-500/20 text-red-300" : "bg-amber-500/20 text-amber-300"}`}>{r.status}</span>
              </div>
            </div>
            {r.status === "pending" && r.user_id && (
              <div className="mt-3 pt-3 border-t border-[#27272A] flex flex-wrap gap-2 items-center">
                <input value={passwords[r.id] || ""} onChange={(e) => setPasswords({ ...passwords, [r.id]: e.target.value })} placeholder="Yeni şifre (boş bırakırsan otomatik üretilir)" className="admin-input flex-1 min-w-[220px]" />
                <button onClick={() => setPasswords({ ...passwords, [r.id]: generatePwd() })} className="admin-btn-ghost text-xs px-2 py-1">Otomatik üret</button>
                <button onClick={() => resetPassword(r)} data-testid={`pr-reset-${r.id}`} className="admin-btn flex items-center gap-1"><Key className="w-4 h-4" /> Şifre Ata</button>
                <input value={notes[r.id] || ""} onChange={(e) => setNotes({ ...notes, [r.id]: e.target.value })} placeholder="Red nedeni" className="admin-input" />
                <button onClick={() => reject(r.id)} data-testid={`pr-reject-${r.id}`} className="admin-btn-ghost text-red-400 flex items-center gap-1"><XCircle className="w-4 h-4" /> Reddet</button>
              </div>
            )}
            {passwords[r.id] && r.status === "resolved" && (
              <div className="mt-3 pt-3 border-t border-emerald-500/30 flex items-center gap-2 text-sm">
                <CheckCircle2 className="w-4 h-4 text-emerald-400" />
                <span className="text-white/60">Yeni şifre:</span>
                <code className="bg-emerald-500/20 px-2 py-1 rounded text-emerald-200">{passwords[r.id]}</code>
                <button onClick={() => copy(passwords[r.id])} className="admin-btn-ghost text-xs px-2 py-1">Kopyala</button>
                <span className="text-xs text-white/40">Bu şifreyi kullanıcıya iletin (SMS/telefon).</span>
              </div>
            )}
          </div>
        ))}
        {items.length === 0 && <div className="text-center text-white/40 py-16">Bu sekmede talep yok.</div>}
      </div>
    </div>
  );
}
